import momentTz from 'moment-timezone';
import { registerDecorator, ValidationOptions, ValidationArguments } from 'class-validator';

import { ScheduleException } from 'src/models/BusinessHours/BusinessHours';

export function IsStartBeforeStopDateTime(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: 'isStartBeforeStopDateTime',
      target: object.constructor,
      propertyName: propertyName,
      constraints: [],
      options: validationOptions,
      validator: {
        validate(currentPropertyValue: string, args: ValidationArguments) {
          const exception = args.object as ScheduleException;
          if (!currentPropertyValue || !exception.stop) {
            return true;
          }
          const start = momentTz.utc(currentPropertyValue);
          const stop = momentTz.utc(exception.stop);
          return start.isSameOrBefore(stop);
        },
        defaultMessage() {
          return 'Start date/time are after end date/time';
        },
      },
    });
  };
}
